import { GET, PUT } from './api-utils'
import { getBaseUrls } from '../../common/environment-configs'
import { clearCache } from './cache-utils'

const configPathUrl = (storeName) => `/support/stores/${storeName}/configurations`

const retrieveStoresCall = async (baseUrl) => {
  if (baseUrl === undefined || baseUrl == null) {
    return
  }
  return await GET(baseUrl + '/support/stores').then((response) => {
    return response ? response.data : null
  })
}

export const getStores = async (env) => {
  const stores = {}
  const requests = []
  const baseUrls = getBaseUrls(env)

  for (const brand in baseUrls) {
    requests.push(retrieveStoresCall(baseUrls[brand]).then((result) => { stores[brand] = result }
    ))
  }
  await Promise.allSettled(requests)
  return stores
}

const setConfigurationsCall = async (baseUrl, storeName, configurations) => {
  if (baseUrl === undefined || baseUrl == null) {
    return
  }
  return await PUT(baseUrl + configPathUrl(storeName), configurations).then((response) => {
    return response ? response.data : null
  })
}

export const setConfigurations = async (env, brand, storeName, configurations) => {
  setConfigurationsCall(getBaseUrls(env)[brand], storeName, configurations)
  clearCache(env, brand)
}
